import React, {Component} from 'react'; 
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import moment from 'moment'; 
import './news-timeline.css'; 

const newsIcon = require('../../../assets/news-icon.png')

export class NewsTimeline extends Component {

    render()
    {
        const { news, position, primaryColor } = this.props 
        if (news.length === 0) return null
        return (
           
            <VerticalTimeline>
                {
                    news.items.map((n, i) => 
                    <VerticalTimelineElement
                        key={i}
                        className="vertical-timeline-element--notification"
                        date={moment(n.pubDate).locale('fr').format("LLLL")}
                        position={position}
                        iconStyle={{ 
                            backgroundImage: `url(${newsIcon})`,
                            backgroundSize: 'cover', 
                            backgroundColor: primaryColor, 
                            color: '#fff' }}
                        >
                        <h3 className="vertical-timeline-element-title">{n.title}</h3>
                        <p>
                            {n.description.split("...")[0]}...
                        </p>
                        <img src={n.image.split("|")[0]} alt="" width="100%"/>
                    </VerticalTimelineElement>  
                )
                }
                </VerticalTimeline>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/News/NewsTimeline/index.js